/**
 * Composable for order status formatting
 */
export function useOrderFormatters() {
  /**
   * Get status label in Czech
   */
  const getStatusLabel = (status: string): string => {
    switch (status) {
      case 'new':
        return 'Nová'
      case 'paid':
        return 'Zaplacená'
      case 'completed':
        return 'Dokončená'
      case 'cancelled':
        return 'Zrušená'
      case 'system':
        return 'Systémová'
      default:
        return status
    }
  }

  /**
   * Get status badge variant
   */
  const getStatusVariant = (status: string): 'blue' | 'success' | 'purple' | 'error' | 'gray' => {
    switch (status) {
      case 'new':
        return 'blue'
      case 'paid':
        return 'success'
      case 'completed':
        return 'purple'
      case 'cancelled':
        return 'error'
      case 'system':
        return 'gray'
      default:
        return 'gray'
    }
  }

  return {
    getStatusLabel,
    getStatusVariant,
  }
}
